import { ClientPrice } from '@fukku/price/client/ClientPrice'
import textHeadingM from '@fukku/styles/texts/textHeadingM.module.css'

import type { FragmentItemsFieldsFragment } from 'cart/services/fragments.generated'
import type { ItemPromotion } from 'codegen/src/gateway/types'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import type { Prices } from 'product/types/Prices'
import type { ReactNode } from 'react'
import { parsePriceData } from '../../utils/parsePriceData'
import styles from './Price.module.css'

interface PriceProps {
	readonly price: FragmentItemsFieldsFragment['price']
	readonly promoCode: ItemPromotion | undefined
	readonly textStyle?: string
	readonly horizontal?: boolean
}

export const Price = ({
	price,
	promoCode,
	textStyle = textHeadingM.className,
	horizontal = false,
}: PriceProps): ReactNode => {
	const {
		country: { hasPriceHistory },
	} = useMasterData()

	const parsedPrices: Prices = parsePriceData(price, promoCode, hasPriceHistory)

	return (
		<ClientPrice
			showDiscount={false}
			align='center'
			prices={parsedPrices}
			horizontal={horizontal}
			classes={{
				price: textStyle,
				discountRate: textStyle,
				additionalPrice: styles.hidden,
			}}
			showAdditionalCurrencies={false}
		/>
	)
}
